import './company.svelte.css.proxy.js';
/* src/routes/company.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Columns from "../../_components/column/Columns.svelte.js";
import Column from "../../_components/column/Column.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/block/Title.svelte.js";
import Heading from "../../_components/block/Heading.svelte.js";
import Hr from "../../_components/element/Hr.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";
import Table from "../../_components/element/Table.svelte.js";

function create_default_slot_33(ctx) {
	let breadcrumb;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[0] } });

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
		}
	};
}

// (33:2) <Section kind="top-small">
function create_default_slot_32(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_33] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (41:2) <Wrap fullOnMobile>
function create_default_slot_31(ctx) {
	let title;
	let current;

	title = new Title({
			props: { name: "会社情報", en: "Company profile" }
		});

	return {
		c() {
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
		}
	};
}

// (40:0) <Section kind="gapless">
function create_default_slot_30(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_31] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (50:6) <Item>
function create_default_slot_29(ctx) {
	let div2;
	let p0;
	let t0;
	let br;
	let t1;
	let t2;
	let div1;
	let div0;
	let p1;
	let t3;
	let t4;
	let p2;
	let span0;
	let t5;
	let t6;
	let span1;
	let t7;

	return {
		c() {
			div2 = element("div");
			p0 = element("p");
			t0 = text("私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			br = element("br");
			t1 = text("\n            モットーは、頼れるクルマのプロ集団として、お客様のどのようなご要望にも応えていくこと。その姿勢がお客様からの厚い信頼につながりました。自動車業界はいま、電気自動車の普及や自動運転など大きな変革にありますが、私たちのこの姿勢は不変です。その上で、こうした自動車の進化に対応する新 しい技術を積極的に取り入れることで、安全・安心で快適なクルマ社会のさらなる発展に貢献していきたいと考えています。");
			t2 = space();
			div1 = element("div");
			div0 = element("div");
			p1 = element("p");
			t3 = text("協和自動車有限会社");
			t4 = space();
			p2 = element("p");
			span0 = element("span");
			t5 = text("代表取締役");
			t6 = space();
			span1 = element("span");
			t7 = text("倉賀野 功");
			this.h();
		},
		l(nodes) {
			div2 = claim_element(nodes, "DIV", {});
			var div2_nodes = children(div2);
			p0 = claim_element(div2_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			br = claim_element(p0_nodes, "BR", {});
			t1 = claim_text(p0_nodes, "\n            モットーは、頼れるクルマのプロ集団として、お客様のどのようなご要望にも応えていくこと。その姿勢がお客様からの厚い信頼につながりました。自動車業界はいま、電気自動車の普及や自動運転など大きな変革にありますが、私たちのこの姿勢は不変です。その上で、こうした自動車の進化に対応する新 しい技術を積極的に取り入れることで、安全・安心で快適なクルマ社会のさらなる発展に貢献していきたいと考えています。");
			p0_nodes.forEach(detach);
			t2 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", {});
			var div0_nodes = children(div0);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t3 = claim_text(p1_nodes, "協和自動車有限会社");
			p1_nodes.forEach(detach);
			t4 = claim_space(div0_nodes);
			p2 = claim_element(div0_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			span0 = claim_element(p2_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t5 = claim_text(span0_nodes, "代表取締役");
			span0_nodes.forEach(detach);
			t6 = claim_space(p2_nodes);
			span1 = claim_element(p2_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t7 = claim_text(span1_nodes, "倉賀野 功");
			span1_nodes.forEach(detach);
			p2_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-1jnclsy");
			attr(p1, "class", "company svelte-1jnclsy");
			attr(span1, "class", "name svelte-1jnclsy");
			attr(p2, "class", "svelte-1jnclsy");
			attr(div1, "class", "profile svelte-1jnclsy");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, p0);
			append(p0, t0);
			append(p0, br);
			append(p0, t1);
			append(div2, t2);
			append(div2, div1);
			append(div1, div0);
			append(div0, p1);
			append(p1, t3);
			append(div0, t4);
			append(div0, p2);
			append(p2, span0);
			append(span0, t5);
			append(p2, t6);
			append(p2, span1);
			append(span1, t7);
		},
		d(detaching) {
			if (detaching) detach(div2);
		}
	};
}

// (48:4) <Inner>
function create_default_slot_28(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "ご挨拶",
				image: "/images/coopgaide.png"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_29] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (47:2) <Wrap>
function create_default_slot_27(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_28] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (46:0) <Section kind="small">
function create_default_slot_26(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_27] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (73:2) <Inner>
function create_default_slot_25(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (72:0) <Wrap fullOnMobile>
function create_default_slot_24(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_25] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (82:6) <Item>
function create_default_slot_23(ctx) {
	let ul;
	let li0;
	let t0;
	let t1;
	let li1;
	let t2;
	let t3;
	let li2;
	let t4;
	let t5;
	let li3;
	let t6;

	return {
		c() {
			ul = element("ul");
			li0 = element("li");
			t0 = text("民間車検工場");
			t1 = space();
			li1 = element("li");
			t2 = text("アイチコーポレーション指定サービス工場");
			t3 = space();
			li2 = element("li");
			t4 = text("NCSパートナー工場");
			t5 = space();
			li3 = element("li");
			t6 = text("あいおいニッセイ同和損害保険代理店");
			this.h();
		},
		l(nodes) {
			ul = claim_element(nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t0 = claim_text(li0_nodes, "民間車検工場");
			li0_nodes.forEach(detach);
			t1 = claim_space(ul_nodes);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			t2 = claim_text(li1_nodes, "アイチコーポレーション指定サービス工場");
			li1_nodes.forEach(detach);
			t3 = claim_space(ul_nodes);
			li2 = claim_element(ul_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			t4 = claim_text(li2_nodes, "NCSパートナー工場");
			li2_nodes.forEach(detach);
			t5 = claim_space(ul_nodes);
			li3 = claim_element(ul_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			t6 = claim_text(li3_nodes, "あいおいニッセイ同和損害保険代理店");
			li3_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li0, "class", "svelte-1jnclsy");
			attr(li1, "class", "svelte-1jnclsy");
			attr(li2, "class", "svelte-1jnclsy");
			attr(li3, "class", "svelte-1jnclsy");
			attr(ul, "class", "svelte-1jnclsy");
		},
		m(target, anchor) {
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, t0);
			append(ul, t1);
			append(ul, li1);
			append(li1, t2);
			append(ul, t3);
			append(ul, li2);
			append(li2, t4);
			append(ul, t5);
			append(ul, li3);
			append(li3, t6);
		},
		d(detaching) {
			if (detaching) detach(ul);
		}
	};
}

// (80:4) <Inner>
function create_default_slot_22(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "資格・各種認定",
				image: "/images/coopgaide.png"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_23] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (79:2) <Wrap>
function create_default_slot_21(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_22] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (78:0) <Section kind="small">
function create_default_slot_20(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_21] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (95:2) <Inner>
function create_default_slot_19(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (94:0) <Wrap fullOnMobile>
function create_default_slot_18(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_19] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (105:8) <Table>
function create_default_slot_17(ctx) {
	let tr0;
	let th0;
	let t0;
	let t1;
	let td0;
	let t2;
	let t3;
	let tr1;
	let th1;
	let t4;
	let t5;
	let td1;
	let t6;
	let t7;
	let tr2;
	let th2;
	let t8;
	let t9;
	let td2;
	let t10;
	let t11;
	let tr3;
	let th3;
	let t12;
	let t13;
	let td3;
	let t14;
	let t15;
	let tr4;
	let th4;
	let t16;
	let t17;
	let td4;
	let t18;
	let t19;
	let tr5;
	let th5;
	let t20;
	let t21;
	let td5;
	let t22;
	let t23;
	let tr6;
	let th6;
	let t24;
	let t25;
	let td6;
	let t26;
	let t27;
	let tr7;
	let th7;
	let t28;
	let t29;
	let td7;
	let t30;
	let br0;
	let t31;
	let br1;
	let t32;
	let br2;
	let t33;
	let br3;
	let t34;
	let br4;
	let t35;
	let br5;
	let t36;
	let br6;
	let t37;

	return {
		c() {
			tr0 = element("tr");
			th0 = element("th");
			t0 = text("商　号");
			t1 = space();
			td0 = element("td");
			t2 = text("協和自動車有限会社");
			t3 = space();
			tr1 = element("tr");
			th1 = element("th");
			t4 = text("本社所在地");
			t5 = space();
			td1 = element("td");
			t6 = text("〒371-0018 群馬県前橋市三俣町2丁目1-3");
			t7 = space();
			tr2 = element("tr");
			th2 = element("th");
			t8 = text("設立");
			t9 = space();
			td2 = element("td");
			t10 = text("昭和39年3月（1964年）");
			t11 = space();
			tr3 = element("tr");
			th3 = element("th");
			t12 = text("資本金");
			t13 = space();
			td3 = element("td");
			t14 = text("800万円");
			t15 = space();
			tr4 = element("tr");
			th4 = element("th");
			t16 = text("代表者");
			t17 = space();
			td4 = element("td");
			t18 = text("代表取締役社長　倉賀野 功");
			t19 = space();
			tr5 = element("tr");
			th5 = element("th");
			t20 = text("従業員数");
			t21 = space();
			td5 = element("td");
			t22 = text("18名");
			t23 = space();
			tr6 = element("tr");
			th6 = element("th");
			t24 = text("取引銀行");
			t25 = space();
			td6 = element("td");
			t26 = text("群馬銀行、しののめ信用金庫、北群馬信用金庫");
			t27 = space();
			tr7 = element("tr");
			th7 = element("th");
			t28 = text("主な取引先");
			t29 = space();
			td7 = element("td");
			t30 = text("東京電力株式会社");
			br0 = element("br");
			t31 = text("\n              株式会社エヌ・ティ・ティ エムイー");
			br1 = element("br");
			t32 = text("\n              株式会社関電工");
			br2 = element("br");
			t33 = text("\n              群馬電工株式会社");
			br3 = element("br");
			t34 = text("\n              株式会社ミライトテクノロジーズ");
			br4 = element("br");
			t35 = text("\n              株式会社協和エクシオ");
			br5 = element("br");
			t36 = text("\n              日本カーソリューションズ株式会社");
			br6 = element("br");
			t37 = text("\n              オリックス株式会社");
		},
		l(nodes) {
			tr0 = claim_element(nodes, "TR", {});
			var tr0_nodes = children(tr0);
			th0 = claim_element(tr0_nodes, "TH", {});
			var th0_nodes = children(th0);
			t0 = claim_text(th0_nodes, "商　号");
			th0_nodes.forEach(detach);
			t1 = claim_space(tr0_nodes);
			td0 = claim_element(tr0_nodes, "TD", {});
			var td0_nodes = children(td0);
			t2 = claim_text(td0_nodes, "協和自動車有限会社");
			td0_nodes.forEach(detach);
			tr0_nodes.forEach(detach);
			t3 = claim_space(nodes);
			tr1 = claim_element(nodes, "TR", {});
			var tr1_nodes = children(tr1);
			th1 = claim_element(tr1_nodes, "TH", {});
			var th1_nodes = children(th1);
			t4 = claim_text(th1_nodes, "本社所在地");
			th1_nodes.forEach(detach);
			t5 = claim_space(tr1_nodes);
			td1 = claim_element(tr1_nodes, "TD", {});
			var td1_nodes = children(td1);
			t6 = claim_text(td1_nodes, "〒371-0018 群馬県前橋市三俣町2丁目1-3");
			td1_nodes.forEach(detach);
			tr1_nodes.forEach(detach);
			t7 = claim_space(nodes);
			tr2 = claim_element(nodes, "TR", {});
			var tr2_nodes = children(tr2);
			th2 = claim_element(tr2_nodes, "TH", {});
			var th2_nodes = children(th2);
			t8 = claim_text(th2_nodes, "設立");
			th2_nodes.forEach(detach);
			t9 = claim_space(tr2_nodes);
			td2 = claim_element(tr2_nodes, "TD", {});
			var td2_nodes = children(td2);
			t10 = claim_text(td2_nodes, "昭和39年3月（1964年）");
			td2_nodes.forEach(detach);
			tr2_nodes.forEach(detach);
			t11 = claim_space(nodes);
			tr3 = claim_element(nodes, "TR", {});
			var tr3_nodes = children(tr3);
			th3 = claim_element(tr3_nodes, "TH", {});
			var th3_nodes = children(th3);
			t12 = claim_text(th3_nodes, "資本金");
			th3_nodes.forEach(detach);
			t13 = claim_space(tr3_nodes);
			td3 = claim_element(tr3_nodes, "TD", {});
			var td3_nodes = children(td3);
			t14 = claim_text(td3_nodes, "800万円");
			td3_nodes.forEach(detach);
			tr3_nodes.forEach(detach);
			t15 = claim_space(nodes);
			tr4 = claim_element(nodes, "TR", {});
			var tr4_nodes = children(tr4);
			th4 = claim_element(tr4_nodes, "TH", {});
			var th4_nodes = children(th4);
			t16 = claim_text(th4_nodes, "代表者");
			th4_nodes.forEach(detach);
			t17 = claim_space(tr4_nodes);
			td4 = claim_element(tr4_nodes, "TD", {});
			var td4_nodes = children(td4);
			t18 = claim_text(td4_nodes, "代表取締役社長　倉賀野 功");
			td4_nodes.forEach(detach);
			tr4_nodes.forEach(detach);
			t19 = claim_space(nodes);
			tr5 = claim_element(nodes, "TR", {});
			var tr5_nodes = children(tr5);
			th5 = claim_element(tr5_nodes, "TH", {});
			var th5_nodes = children(th5);
			t20 = claim_text(th5_nodes, "従業員数");
			th5_nodes.forEach(detach);
			t21 = claim_space(tr5_nodes);
			td5 = claim_element(tr5_nodes, "TD", {});
			var td5_nodes = children(td5);
			t22 = claim_text(td5_nodes, "18名");
			td5_nodes.forEach(detach);
			tr5_nodes.forEach(detach);
			t23 = claim_space(nodes);
			tr6 = claim_element(nodes, "TR", {});
			var tr6_nodes = children(tr6);
			th6 = claim_element(tr6_nodes, "TH", {});
			var th6_nodes = children(th6);
			t24 = claim_text(th6_nodes, "取引銀行");
			th6_nodes.forEach(detach);
			t25 = claim_space(tr6_nodes);
			td6 = claim_element(tr6_nodes, "TD", {});
			var td6_nodes = children(td6);
			t26 = claim_text(td6_nodes, "群馬銀行、しののめ信用金庫、北群馬信用金庫");
			td6_nodes.forEach(detach);
			tr6_nodes.forEach(detach);
			t27 = claim_space(nodes);
			tr7 = claim_element(nodes, "TR", {});
			var tr7_nodes = children(tr7);
			th7 = claim_element(tr7_nodes, "TH", {});
			var th7_nodes = children(th7);
			t28 = claim_text(th7_nodes, "主な取引先");
			th7_nodes.forEach(detach);
			t29 = claim_space(tr7_nodes);
			td7 = claim_element(tr7_nodes, "TD", {});
			var td7_nodes = children(td7);
			t30 = claim_text(td7_nodes, "東京電力株式会社");
			br0 = claim_element(td7_nodes, "BR", {});
			t31 = claim_text(td7_nodes, "\n              株式会社エヌ・ティ・ティ エムイー");
			br1 = claim_element(td7_nodes, "BR", {});
			t32 = claim_text(td7_nodes, "\n              株式会社関電工");
			br2 = claim_element(td7_nodes, "BR", {});
			t33 = claim_text(td7_nodes, "\n              群馬電工株式会社");
			br3 = claim_element(td7_nodes, "BR", {});
			t34 = claim_text(td7_nodes, "\n              株式会社ミライトテクノロジーズ");
			br4 = claim_element(td7_nodes, "BR", {});
			t35 = claim_text(td7_nodes, "\n              株式会社協和エクシオ");
			br5 = claim_element(td7_nodes, "BR", {});
			t36 = claim_text(td7_nodes, "\n              日本カーソリューションズ株式会社");
			br6 = claim_element(td7_nodes, "BR", {});
			t37 = claim_text(td7_nodes, "\n              オリックス株式会社");
			td7_nodes.forEach(detach);
			tr7_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, tr0, anchor);
			append(tr0, th0);
			append(th0, t0);
			append(tr0, t1);
			append(tr0, td0);
			append(td0, t2);
			insert(target, t3, anchor);
			insert(target, tr1, anchor);
			append(tr1, th1);
			append(th1, t4);
			append(tr1, t5);
			append(tr1, td1);
			append(td1, t6);
			insert(target, t7, anchor);
			insert(target, tr2, anchor);
			append(tr2, th2);
			append(th2, t8);
			append(tr2, t9);
			append(tr2, td2);
			append(td2, t10);
			insert(target, t11, anchor);
			insert(target, tr3, anchor);
			append(tr3, th3);
			append(th3, t12);
			append(tr3, t13);
			append(tr3, td3);
			append(td3, t14);
			insert(target, t15, anchor);
			insert(target, tr4, anchor);
			append(tr4, th4);
			append(th4, t16);
			append(tr4, t17);
			append(tr4, td4);
			append(td4, t18);
			insert(target, t19, anchor);
			insert(target, tr5, anchor);
			append(tr5, th5);
			append(th5, t20);
			append(tr5, t21);
			append(tr5, td5);
			append(td5, t22);
			insert(target, t23, anchor);
			insert(target, tr6, anchor);
			append(tr6, th6);
			append(th6, t24);
			append(tr6, t25);
			append(tr6, td6);
			append(td6, t26);
			insert(target, t27, anchor);
			insert(target, tr7, anchor);
			append(tr7, th7);
			append(th7, t28);
			append(tr7, t29);
			append(tr7, td7);
			append(td7, t30);
			append(td7, br0);
			append(td7, t31);
			append(td7, br1);
			append(td7, t32);
			append(td7, br2);
			append(td7, t33);
			append(td7, br3);
			append(td7, t34);
			append(td7, br4);
			append(td7, t35);
			append(td7, br5);
			append(td7, t36);
			append(td7, br6);
			append(td7, t37);
		},
		d(detaching) {
			if (detaching) detach(tr0);
			if (detaching) detach(t3);
			if (detaching) detach(tr1);
			if (detaching) detach(t7);
			if (detaching) detach(tr2);
			if (detaching) detach(t11);
			if (detaching) detach(tr3);
			if (detaching) detach(t15);
			if (detaching) detach(tr4);
			if (detaching) detach(t19);
			if (detaching) detach(tr5);
			if (detaching) detach(t23);
			if (detaching) detach(tr6);
			if (detaching) detach(t27);
			if (detaching) detach(tr7);
		}
	};
}

// (104:6) <Item>
function create_default_slot_16(ctx) {
	let table;
	let current;

	table = new Table({
			props: {
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(table.$$.fragment);
		},
		l(nodes) {
			claim_component(table.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(table, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const table_changes = {};

			if (dirty & /*$$scope*/ 2) {
				table_changes.$$scope = { dirty, ctx };
			}

			table.$set(table_changes);
		},
		i(local) {
			if (current) return;
			transition_in(table.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(table.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(table, detaching);
		}
	};
}

// (102:4) <Inner>
function create_default_slot_15(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "概要",
				image: "/images/coopgaide.png"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (101:2) <Wrap fullOnMobile>
function create_default_slot_14(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (100:0) <Section kind="small">
function create_default_slot_13(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (154:2) <Inner>
function create_default_slot_12(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (153:0) <Wrap fullOnMobile>
function create_default_slot_11(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (163:6) <Item>
function create_default_slot_10(ctx) {
	let div;
	let p0;
	let t0;
	let t1;
	let p1;
	let t2;
	let t3;
	let p2;
	let t4;
	let t5;
	let p3;
	let t6;
	let t7;
	let p4;
	let t8;
	let t9;
	let p5;
	let t10;
	let t11;
	let p6;
	let t12;
	let t13;
	let p7;
	let t14;
	let t15;
	let p8;
	let t16;
	let t17;
	let p9;
	let t18;
	let t19;
	let p10;
	let t20;
	let t21;
	let p11;
	let t22;
	let t23;
	let p12;
	let t24;
	let t25;
	let p13;
	let t26;
	let t27;
	let p14;
	let t28;

	return {
		c() {
			div = element("div");
			p0 = element("p");
			t0 = text("昭和39年（1964年）");
			t1 = space();
			p1 = element("p");
			t2 = text("3月、前橋市三俣町595番地にて協和自動車有限会社を設立。");
			t3 = space();
			p2 = element("p");
			t4 = text("日産プリンス自動車様、関東いすゞ自動車様のサービス工場となり、その他一般整備を主体とする。");
			t5 = space();
			p3 = element("p");
			t6 = text("昭和45年（1970年）");
			t7 = space();
			p4 = element("p");
			t8 = text("愛知車両（株）[現:（株）アイチコーポレーション]様の群馬県指定サービス工場及び販売取次店となる。");
			t9 = space();
			p5 = element("p");
			t10 = text("昭和46年（1971年）");
			t11 = space();
			p6 = element("p");
			t12 = text("大型自動車の認証取得。");
			t13 = space();
			p7 = element("p");
			t14 = text("東京電力（株）様、（株）関電工様、群馬電工（株）様、NTT電報電話局様などの特殊自動車の整備工場となる。");
			t15 = space();
			p8 = element("p");
			t16 = text("昭和54年（1979年）");
			t17 = space();
			p9 = element("p");
			t18 = text("労働安全衛生法第54条の3第一項の特定自主検査業者となる。");
			t19 = space();
			p10 = element("p");
			t20 = text("昭和55年（1980年）");
			t21 = space();
			p11 = element("p");
			t22 = text("2月、工場増設。");
			t23 = space();
			p12 = element("p");
			t24 = text("8月、民間車検整備指定工場となる。");
			t25 = space();
			p13 = element("p");
			t26 = text("平成8年（1996年）");
			t27 = space();
			p14 = element("p");
			t28 = text("11月、前橋市鳥取町に芳賀特装工場を新設。");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			p0 = claim_element(div_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "昭和39年（1964年）");
			p0_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p1 = claim_element(div_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t2 = claim_text(p1_nodes, "3月、前橋市三俣町595番地にて協和自動車有限会社を設立。");
			p1_nodes.forEach(detach);
			t3 = claim_space(div_nodes);
			p2 = claim_element(div_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			t4 = claim_text(p2_nodes, "日産プリンス自動車様、関東いすゞ自動車様のサービス工場となり、その他一般整備を主体とする。");
			p2_nodes.forEach(detach);
			t5 = claim_space(div_nodes);
			p3 = claim_element(div_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t6 = claim_text(p3_nodes, "昭和45年（1970年）");
			p3_nodes.forEach(detach);
			t7 = claim_space(div_nodes);
			p4 = claim_element(div_nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t8 = claim_text(p4_nodes, "愛知車両（株）[現:（株）アイチコーポレーション]様の群馬県指定サービス工場及び販売取次店となる。");
			p4_nodes.forEach(detach);
			t9 = claim_space(div_nodes);
			p5 = claim_element(div_nodes, "P", { class: true });
			var p5_nodes = children(p5);
			t10 = claim_text(p5_nodes, "昭和46年（1971年）");
			p5_nodes.forEach(detach);
			t11 = claim_space(div_nodes);
			p6 = claim_element(div_nodes, "P", { class: true });
			var p6_nodes = children(p6);
			t12 = claim_text(p6_nodes, "大型自動車の認証取得。");
			p6_nodes.forEach(detach);
			t13 = claim_space(div_nodes);
			p7 = claim_element(div_nodes, "P", { class: true });
			var p7_nodes = children(p7);
			t14 = claim_text(p7_nodes, "東京電力（株）様、（株）関電工様、群馬電工（株）様、NTT電報電話局様などの特殊自動車の整備工場となる。");
			p7_nodes.forEach(detach);
			t15 = claim_space(div_nodes);
			p8 = claim_element(div_nodes, "P", { class: true });
			var p8_nodes = children(p8);
			t16 = claim_text(p8_nodes, "昭和54年（1979年）");
			p8_nodes.forEach(detach);
			t17 = claim_space(div_nodes);
			p9 = claim_element(div_nodes, "P", { class: true });
			var p9_nodes = children(p9);
			t18 = claim_text(p9_nodes, "労働安全衛生法第54条の3第一項の特定自主検査業者となる。");
			p9_nodes.forEach(detach);
			t19 = claim_space(div_nodes);
			p10 = claim_element(div_nodes, "P", { class: true });
			var p10_nodes = children(p10);
			t20 = claim_text(p10_nodes, "昭和55年（1980年）");
			p10_nodes.forEach(detach);
			t21 = claim_space(div_nodes);
			p11 = claim_element(div_nodes, "P", { class: true });
			var p11_nodes = children(p11);
			t22 = claim_text(p11_nodes, "2月、工場増設。");
			p11_nodes.forEach(detach);
			t23 = claim_space(div_nodes);
			p12 = claim_element(div_nodes, "P", { class: true });
			var p12_nodes = children(p12);
			t24 = claim_text(p12_nodes, "8月、民間車検整備指定工場となる。");
			p12_nodes.forEach(detach);
			t25 = claim_space(div_nodes);
			p13 = claim_element(div_nodes, "P", { class: true });
			var p13_nodes = children(p13);
			t26 = claim_text(p13_nodes, "平成8年（1996年）");
			p13_nodes.forEach(detach);
			t27 = claim_space(div_nodes);
			p14 = claim_element(div_nodes, "P", { class: true });
			var p14_nodes = children(p14);
			t28 = claim_text(p14_nodes, "11月、前橋市鳥取町に芳賀特装工場を新設。");
			p14_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-1jnclsy");
			attr(p1, "class", "indent svelte-1jnclsy");
			attr(p2, "class", "indent svelte-1jnclsy");
			attr(p3, "class", "svelte-1jnclsy");
			attr(p4, "class", "indent svelte-1jnclsy");
			attr(p5, "class", "svelte-1jnclsy");
			attr(p6, "class", "indent svelte-1jnclsy");
			attr(p7, "class", "indent svelte-1jnclsy");
			attr(p8, "class", "svelte-1jnclsy");
			attr(p9, "class", "indent svelte-1jnclsy");
			attr(p10, "class", "svelte-1jnclsy");
			attr(p11, "class", "indent svelte-1jnclsy");
			attr(p12, "class", "indent svelte-1jnclsy");
			attr(p13, "class", "svelte-1jnclsy");
			attr(p14, "class", "indent svelte-1jnclsy");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p0);
			append(p0, t0);
			append(div, t1);
			append(div, p1);
			append(p1, t2);
			append(div, t3);
			append(div, p2);
			append(p2, t4);
			append(div, t5);
			append(div, p3);
			append(p3, t6);
			append(div, t7);
			append(div, p4);
			append(p4, t8);
			append(div, t9);
			append(div, p5);
			append(p5, t10);
			append(div, t11);
			append(div, p6);
			append(p6, t12);
			append(div, t13);
			append(div, p7);
			append(p7, t14);
			append(div, t15);
			append(div, p8);
			append(p8, t16);
			append(div, t17);
			append(div, p9);
			append(p9, t18);
			append(div, t19);
			append(div, p10);
			append(p10, t20);
			append(div, t21);
			append(div, p11);
			append(p11, t22);
			append(div, t23);
			append(div, p12);
			append(p12, t24);
			append(div, t25);
			append(div, p13);
			append(p13, t26);
			append(div, t27);
			append(div, p14);
			append(p14, t28);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (161:4) <Inner>
function create_default_slot_9(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "沿革",
				image: "/images/coopgaide.png"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (160:2) <Wrap>
function create_default_slot_8(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (159:0) <Section kind="small">
function create_default_slot_7(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (192:2) <Inner>
function create_default_slot_6(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (191:0) <Wrap fullOnMobile>
function create_default_slot_5(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (201:6) <Item>
function create_default_slot_4(ctx) {
	let div;
	let p0;
	let t0;
	let t1;
	let p1;
	let t2;

	return {
		c() {
			div = element("div");
			p0 = element("p");
			t0 = text("群馬県前橋市三俣町2丁目1-3");
			t1 = space();
			p1 = element("p");
			t2 = text("TEL.027-231-9008 FAX.027-231-9231");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			p0 = claim_element(div_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "群馬県前橋市三俣町2丁目1-3");
			p0_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p1 = claim_element(div_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t2 = claim_text(p1_nodes, "TEL.027-231-9008 FAX.027-231-9231");
			p1_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "svelte-1jnclsy");
			attr(p1, "class", "svelte-1jnclsy");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p0);
			append(p0, t0);
			append(div, t1);
			append(div, p1);
			append(p1, t2);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (208:6) <Item>
function create_default_slot_3(ctx) {
	let iframe;
	let iframe_src_value;

	return {
		c() {
			iframe = element("iframe");
			this.h();
		},
		l(nodes) {
			iframe = claim_element(nodes, "IFRAME", {
				src: true,
				width: true,
				height: true,
				frameborder: true,
				style: true,
				allowfullscreen: true,
				"aria-hidden": true,
				tabindex: true
			});

			children(iframe).forEach(detach);
			this.h();
		},
		h() {
			if (iframe.src !== (iframe_src_value = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3211.4250650682457!2d139.08074721527856!3d36.39890988003329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601ef3a8354fc103%3A0xb10ffd0200cc8708!2z44CSMzcxLTAwMTgg576k6aas55yM5YmN5qmL5biC5LiJ5L-j55S677yS5LiB55uu77yR4oiS77yT!5e0!3m2!1sja!2sjp!4v1613173695422!5m2!1sja!2sjp")) attr(iframe, "src", iframe_src_value);
			attr(iframe, "width", "100%");
			attr(iframe, "height", "450");
			attr(iframe, "frameborder", "0");
			set_style(iframe, "border", "0");
			iframe.allowFullscreen = "";
			attr(iframe, "aria-hidden", "false");
			attr(iframe, "tabindex", "0");
		},
		m(target, anchor) {
			insert(target, iframe, anchor);
		},
		d(detaching) {
			if (detaching) detach(iframe);
		}
	};
}

// (199:4) <Inner>
function create_default_slot_2(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "本社所在地",
				image: "/images/coopgaide.png"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (198:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (197:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let div;
	let section0;
	let t2;
	let section1;
	let t3;
	let section2;
	let t4;
	let wrap0;
	let t5;
	let section3;
	let t6;
	let wrap1;
	let t7;
	let section4;
	let t8;
	let wrap2;
	let t9;
	let section5;
	let t10;
	let wrap3;
	let t11;
	let section6;
	let current;
	nav = new Nav({ props: { segment: "company" } });

	section0 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_32] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "gapless",
				$$slots: { default: [create_default_slot_30] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_26] },
				$$scope: { ctx }
			}
		});

	wrap0 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_24] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_20] },
				$$scope: { ctx }
			}
		});

	wrap1 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_18] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	wrap2 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	section5 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	wrap3 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section6 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			div = element("div");
			create_component(section0.$$.fragment);
			t2 = space();
			create_component(section1.$$.fragment);
			t3 = space();
			create_component(section2.$$.fragment);
			t4 = space();
			create_component(wrap0.$$.fragment);
			t5 = space();
			create_component(section3.$$.fragment);
			t6 = space();
			create_component(wrap1.$$.fragment);
			t7 = space();
			create_component(section4.$$.fragment);
			t8 = space();
			create_component(wrap2.$$.fragment);
			t9 = space();
			create_component(section5.$$.fragment);
			t10 = space();
			create_component(wrap3.$$.fragment);
			t11 = space();
			create_component(section6.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-wcawav\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(section0.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			t2 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(wrap0.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(wrap1.$$.fragment, nodes);
			t7 = claim_space(nodes);
			claim_component(section4.$$.fragment, nodes);
			t8 = claim_space(nodes);
			claim_component(wrap2.$$.fragment, nodes);
			t9 = claim_space(nodes);
			claim_component(section5.$$.fragment, nodes);
			t10 = claim_space(nodes);
			claim_component(wrap3.$$.fragment, nodes);
			t11 = claim_space(nodes);
			claim_component(section6.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "会社情報 | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社の会社情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/compnay/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "会社情報 | 協和自動車有限会社 | 群馬で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社の会社情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
			attr(div, "class", "hide-on-mobile");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			insert(target, div, anchor);
			mount_component(section0, div, null);
			insert(target, t2, anchor);
			mount_component(section1, target, anchor);
			insert(target, t3, anchor);
			mount_component(section2, target, anchor);
			insert(target, t4, anchor);
			mount_component(wrap0, target, anchor);
			insert(target, t5, anchor);
			mount_component(section3, target, anchor);
			insert(target, t6, anchor);
			mount_component(wrap1, target, anchor);
			insert(target, t7, anchor);
			mount_component(section4, target, anchor);
			insert(target, t8, anchor);
			mount_component(wrap2, target, anchor);
			insert(target, t9, anchor);
			mount_component(section5, target, anchor);
			insert(target, t10, anchor);
			mount_component(wrap3, target, anchor);
			insert(target, t11, anchor);
			mount_component(section6, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const wrap0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap0_changes.$$scope = { dirty, ctx };
			}

			wrap0.$set(wrap0_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const wrap1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap1_changes.$$scope = { dirty, ctx };
			}

			wrap1.$set(wrap1_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
			const wrap2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap2_changes.$$scope = { dirty, ctx };
			}

			wrap2.$set(wrap2_changes);
			const section5_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section5_changes.$$scope = { dirty, ctx };
			}

			section5.$set(section5_changes);
			const wrap3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap3_changes.$$scope = { dirty, ctx };
			}

			wrap3.$set(wrap3_changes);
			const section6_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section6_changes.$$scope = { dirty, ctx };
			}

			section6.$set(section6_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(wrap0.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(wrap1.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			transition_in(wrap2.$$.fragment, local);
			transition_in(section5.$$.fragment, local);
			transition_in(wrap3.$$.fragment, local);
			transition_in(section6.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(wrap0.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(wrap1.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			transition_out(wrap2.$$.fragment, local);
			transition_out(section5.$$.fragment, local);
			transition_out(wrap3.$$.fragment, local);
			transition_out(section6.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(div);
			destroy_component(section0);
			if (detaching) detach(t2);
			destroy_component(section1, detaching);
			if (detaching) detach(t3);
			destroy_component(section2, detaching);
			if (detaching) detach(t4);
			destroy_component(wrap0, detaching);
			if (detaching) detach(t5);
			destroy_component(section3, detaching);
			if (detaching) detach(t6);
			destroy_component(wrap1, detaching);
			if (detaching) detach(t7);
			destroy_component(section4, detaching);
			if (detaching) detach(t8);
			destroy_component(wrap2, detaching);
			if (detaching) detach(t9);
			destroy_component(section5, detaching);
			if (detaching) detach(t10);
			destroy_component(wrap3, detaching);
			if (detaching) detach(t11);
			destroy_component(section6, detaching);
		}
	};
}

function instance($$self) {
	const paths = [{ name: "HOME", href: "/" }, { name: "会社情報" }];
	return [paths];
}

class Company extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Company;
//# sourceMappingURL=company.svelte.js.map
